export default __webpack_public_path__ + "static/media/SideTable.d3c0ab52.gltf";